import React from "react";
import {
	TextField,
	Radio,
	RadioGroup,
	FormControlLabel,
	FormControl,
	FormLabel,
} from "@mui/material";

export default function InputCard(props) {
	const {
		label,
		handleData,
		field,
		err,
		errTxt,
		arabicLabel,
		value,
		options,
		fontStyle,
		type,
	} = props;
	return (
		<>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
				}}
			>
				<h3 style={fontStyle}>{`${label}:`}</h3>
				{/* <h3 style={fontStyle}>{`:${arabicLabel}`}</h3> */}
			</div>

			{options ? (
				<RadioGroup
					aria-labelledby="demo-controlled-radio-buttons-group"
					name="controlled-radio-buttons-group"
					value={value}
					onChange={(e) => handleData(e.target.value, "location")}
				>
					<FormControlLabel
						value="Aspire Dome"
						control={<Radio />}
						label="Aspire Dome"
					/>
					<FormControlLabel
						style={fontStyle}
						value="Aspire Ladies Club"
						control={<Radio />}
						label="Aspire Ladies Club"
					/>
					<FormControlLabel
						style={fontStyle}
						value="Barwa"
						control={<Radio />}
						label="Barwa"
					/>
				</RadioGroup>
			) : type === "date" ? (
				<TextField
					fullWidth
					// label={label}
					id="fullWidth"
					onChange={(e) => handleData(e.target.value, field)}
					error={err}
					helperText={errTxt}
					type={type}
				/>
			) : type === "file" ? (
				<TextField
					fullWidth
					label={label}
					id="fullWidth"
					onChange={(e) => handleData(e)}
					type={type}
				/>
			) : (
				<TextField
					fullWidth
					label={label}
					id="fullWidth"
					onChange={(e) => handleData(e.target.value, field)}
					error={err}
					helperText={errTxt}
					type={type}
				/>
			)}
		</>
	);
}
